function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function headerToggler() {
  var body = document.querySelector('body');
  var toggler = document.querySelector('.header .navbar-toggler');
  if (!toggler) return;
  toggler.addEventListener('click', function (e) {
    e.preventDefault();
    body.classList.toggle('nav-active');
    this.classList.toggle('active');
  });
}

function fixedHeader() {
  var header = document.querySelector('header.header');
  var fixedHeaderCls = 'header--fixed';
  window.addEventListener('scroll', function (e) {
    var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;

    if (parseInt(currentScroll) >= header.offsetHeight) {
      header.classList.add(fixedHeaderCls);
    } else {
      header.classList.remove(fixedHeaderCls);
    }
  });
}

function paginationTooltip() {
  var pagination = document.querySelector('.pagination');
  if (!pagination) return;
  var paginationList = pagination.querySelector('.pagination__list');
  var paginationLinks = pagination.querySelectorAll('.pagination__link');
  var indexActive = 0;
  paginationLinks.forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      link.classList.add('on-hover');
      paginationList.classList.add('mouse-over');
    });
    pagination.addEventListener('mouseleave', function () {
      link.classList.remove('on-hover');
      paginationList.classList.remove('mouse-over');
    });
  });

  function togglerActiveLink(method) {
    paginationLinks.forEach(function (link, index) {
      if (link.classList.contains('active')) {
        indexActive = index;
        link.classList[method]('active');
      } else {
        if (index === indexActive) {
          link.classList.add('active');
        }
      }
    });
  }
}

function linkedPosts() {
  var linkedPosts = _toConsumableArray(document.querySelectorAll('.js-linked-post'));

  var timeout = 200;
  linkedPosts.forEach(function (post) {
    post.addEventListener('mouseover', function (e) {
      var _this = this;

      var _this$dataset = this.dataset,
          title = _this$dataset.title,
          text = _this$dataset.text,
          linkText = _this$dataset.linkText;
      this.insertAdjacentHTML('beforeend', getLinkedPostHiddenContent(title, text, linkText));
      setTimeout(function () {
        _this.classList.add('active');
      }, timeout);
    });
    post.addEventListener('mouseout', function (e) {
      var el = document.querySelector('.post__hidden-content');
      this.classList.remove('active');
      setTimeout(function () {
        el.remove();
      }, timeout);
    });
  });

  function getLinkedPostHiddenContent(title, text, linkText) {
    return "\n      <div class=\"post__hidden-content\">\n        <div class=\"post__hidden-content-body\">\n          <h6 class=\"post__title-secondary text-green text-uppercase font-normal\">".concat(title, "</h6>\n          <p class=\"post__text font-bold\">").concat(text, "</p>\n        </div>\n        <div class=\"post__more-wrapper\">\n            <span class=\"post__more text-uppercase text-blue\">").concat(linkText, "</span>\n        </div>\n      </div>\n    ");
  }
}

export default function common() {
  headerToggler();
  fixedHeader();
  paginationTooltip();
  linkedPosts();
}